import { ImageResource } from '../image-resource';
import { Seller } from '../seller';
import { Model } from '../model';
export class ModelImage {
    constructor(
        public id?: number,
        public shutdownscreen?: ImageResource,
        public shutdownscreenNoPower?: ImageResource,
        public screensavers?: ImageResource[],
        public seller?: Seller,
        public model?: Model,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/model-image/model-image.model.ts